import React from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';

import RouterLink from './RouterLink';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import IAdd from 'icons/IAdd';

export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
};

const NewButton = ({ comcode, ...otherProps }: ButtonProps) => {
  const { isHidden, label } = useComponentConfiguration(comcode);

  if (isHidden) {
    return null;
  }

  const props = {
    ...otherProps,
    children: label,
  };

  if (props.to) {
    return (
      <RouterLink
        type="primary"
        icon={<IAdd color="white" />}
        style={{ width: '100%', height: 60, padding: '15px' }}
        component={AntButton}
        {...props}
      />
    );
  } else {
    return (
      <AntButton
        type="primary"
        {...props}
        icon={
          <IAdd color="white" svgstyle={{ paddingTop: '5px' }} width="20px" />
        }
        style={{ width: '100%', height: 40 }}
      />
    );
  }
};

export default NewButton;
